var map = {
	"./bs.json": 1052,
	"./da.json": 1053,
	"./de.json": 1054,
	"./en-US.json": 1055,
	"./es.json": 1056,
	"./fi.json": 1057,
	"./fr.json": 1058,
	"./hu.json": 1059,
	"./it.json": 1060,
	"./ja.json": 1061,
	"./nl.json": 1062,
	"./pt.json": 1063,
	"./tr.json": 1064
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 419;